<template>
  <div>
    <alarmLogsEventsModal ref="alarmLogsEventsModal"></alarmLogsEventsModal>
    <alarmChartModal ref="alarmChartModal"></alarmChartModal>
    <Tabs value="problem" type="card">
      <TabPane label="未恢复" name="problem">
        <Card shadow>
          <Row>
            <Col span="24" :md="22">
              <Form inline :model="eventCasesProblem.searchForm" :label-width="60">
                <FormItem label="开始时间">
                  <DatePicker v-model="eventCasesProblem.searchForm.start_time" type="date" class="mob-w-100" style="min-width: 100px"></DatePicker>
                </FormItem>
                <FormItem label="结束时间">
                  <DatePicker v-model="eventCasesProblem.searchForm.end_time" type="date" class="mob-w-100" style="min-width: 100px"></DatePicker>
                </FormItem>
                <FormItem label="告警主机">
                  <Select v-model="eventCasesProblem.searchForm.endpoints" filterable multiple placeholder="" style="min-width:100px">
                    <Option v-for="item in allServerData" :value="item.endpoint" :key="item.endpoint">{{ item.endpoint }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="策略模板">
                  <Select v-model="eventCasesProblem.searchForm.template_id" filterable clearable placeholder="" style="min-width: 150px;">
                    <Option v-for="item in allTemplateData" :value="item.template.id" :key="item.template.id" :label="item.template.tpl_name"></Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getEventCasesProblemData()">搜索</Button>
                  <Button @click="eventCasesSearchProblemReset" style="margin-left: 10px">重置</Button>
                </FormItem>
              </Form>
            </Col>
            <Col span="24" :md="2"><Button type="primary" :style="{float: 'right'}" @click="getEventCasesProblemData()" icon="md-refresh">刷新</Button></Col>
          </Row>
          <Table
            border
            :loading="eventCasesTableProblemLoading"
            :data="eventCasesProblem.data"
            :columns="eventCases.columns"
            :style="{marginTop:'10px'}"
            class="mob-remove-table-fixed">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="eventCasesProblem.count"
                :current="eventCasesProblem.page"
                :page-size="eventCasesProblem.size"
                @on-change="getEventCasesProblemData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="全部" name="all">
        <Card shadow>
          <Row>
            <Col span="24" :md="22">
              <Form inline :model="eventCases.searchForm" :label-width="60">
                <FormItem label="开始时间">
                  <DatePicker v-model="eventCases.searchForm.start_time" type="date" class="mob-w-100" style="min-width: 100px;"></DatePicker>
                </FormItem>
                <FormItem label="结束时间">
                  <DatePicker v-model="eventCases.searchForm.end_time" type="date" class="mob-w-100" style="min-width: 100px"></DatePicker>
                </FormItem>
                <FormItem label="告警主机">
                  <Select v-model="eventCases.searchForm.endpoints" multiple filterable placeholder="" style="min-width:100px">
                    <Option v-for="item in allServerData" :value="item.endpoint" :key="item.endpoint">{{ item.endpoint }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="策略模板">
                  <Select v-model="eventCases.searchForm.template_id" clearable filterable placeholder="" style="min-width: 150px;">
                    <Option v-for="item in allTemplateData" :value="item.template.id" :key="item.template.id" :label="item.template.tpl_name"></Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getEventCasesData()">搜索</Button>
                  <Button @click="eventCasesSearchReset" style="margin-left: 10px">重置</Button>
                </FormItem>
              </Form>
            </Col>
            <Col span="24" :md="2"><Button type="primary" :style="{float: 'right'}" @click="getEventCasesData()" icon="md-refresh">刷新</Button></Col>
          </Row>
          <Table
            border
            :loading="eventCasesTableLoading"
            :data="eventCases.data"
            :columns="eventCases.columns"
            :style="{marginTop:'10px'}"
            class="mob-remove-table-fixed">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="eventCases.count"
                :current="eventCases.page"
                :page-size="eventCases.size"
                @on-change="getEventCasesData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import alarmLogsEventsModal from './components/alarm-logs-events-modal'
import alarmChartModal from './components/chart-modal'
import { getEventCases, getEndpoints, getAllAlarmTemplate, deleteEventCases } from '@/api/monitor'

export default {
  name: 'alarm-logs',
  components: {
    alarmLogsEventsModal,
    alarmChartModal
  },
  data () {
    return {
      allServerData: [],
      allTemplateData: [],
      noDataView: '监控中断',
      eventCasesTableLoading: false,
      eventCases: {
        data: [],
        columns: [
          {
            title: '事件ID',
            key: 'id',
            width: 300,
            align: 'center'
          },
          {
            title: '状态',
            key: 'status',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let color = 'red'
              if (status === 'OK') {
                color = 'green'
              }
              return h('div', [
                h('span', {
                  style: {
                    color: color
                  }
                }, status)
              ])
            }
          },
          {
            title: '告警方式',
            align: 'center',
            width: 120,
            render: (h, params) => {
              let re = []
              let priority = params.row.priority
              if (priority === 1) {
                re.push(h('Tag', '邮件'))
              } else if (priority === 3) {
                re.push(h('Tag', 'IM'))
              } else if (priority === 5) {
                re.push(h('Tag', '短信'))
              } else if (priority === 4) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
              } else if (priority === 6) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', '短信'))
              } else if (priority === 8) {
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
              } else if (priority === 9) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
              } else if (priority === 12) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', '电话'))
              } else if (priority === 14) {
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '电话'))
              } else if (priority === 15) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '电话'))
              } else if (priority === 16) {
                re.push(h('Tag', '电话'))
                re.push(h('Tag', '短信'))
              } else if (priority === 17) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', '短信'))
                re.push(h('Tag', '电话'))
              } else if (priority === 19) {
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
                re.push(h('Tag', '电话'))
              } else if (priority === 20) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
                re.push(h('Tag', '电话'))
              }
              return h('div', re)
            }
          },
          {
            title: '设备',
            key: 'endpoint',
            width: 130,
            align: 'center'
          },
          {
            title: '指标',
            key: 'metric_name',
            width: 200,
            align: 'center'
          },
          {
            title: '触发函数',
            key: 'func',
            width: 90,
            align: 'center'
          },
          {
            title: '触发',
            key: 'cond',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let result = params.row.cond
              if (result === '-1 == -1') {
                result = this.noDataView
              }
              return h('div', [
                h('span', result)
              ])
            }
          },
          {
            title: '时间',
            width: 160,
            key: 'update_at',
            align: 'center',
            render: (h, params) => {
              let time = params.row.update_at
              if (time) {
                return h('span', this.daysBetween(time))
              } else {
                return time
              }
            }
          },
          {
            title: '告警次数',
            width: 150,
            key: 'current_step',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('span', '第' + params.row.current_step + '次 / 最大' + params.row.step + '次')
              ])
            }
          },
          {
            title: '操作',
            key: '',
            width: 150,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.eventsModalOpen(params.row)
                    }
                  }
                }, '更多记录'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.eventCaseDelete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 13,
        searchForm: {
          start_time: '',
          end_time: '',
          endpoints: [],
          template_id: ''
        }
      },
      eventCasesTableProblemLoading: false,
      eventCasesProblem: {
        data: [],
        count: 1,
        page: 1,
        size: 13,
        searchForm: {
          start_time: '',
          end_time: '',
          endpoints: [],
          template_id: ''
        }
      }
    }
  },
  mounted: function () {
    this.getEventCasesProblemData()
    this.getEventCasesData()
    this.getEndpointsFunc()
    this.getAllTemplateList()
  },
  methods: {
    getEventCasesData (value = 1) {
      this.eventCases.page = value
      let params = {
        endpoints: this.eventCases.searchForm.endpoints,
        template_id: this.eventCases.searchForm.template_id,
        size: this.eventCases.size,
        page: this.eventCases.page
      }
      if (this.eventCases.searchForm.start_time) {
        params.start_time = this.eventCases.searchForm.start_time.getTime() / 1000
      }
      if (this.eventCases.searchForm.end_time) {
        params.end_time = this.eventCases.searchForm.end_time.getTime() / 1000 + 86400
      }
      this.eventCasesTableLoading = true
      getEventCases(params).then(res => {
        this.eventCases.data = res.data.data
        this.eventCases.count = res.data.count
        this.eventCasesTableLoading = false
      }).catch(res => {
        this.eventCasesTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取告警记录失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取告警记录失败！服务器无响应'
          })
        }
      })
    },
    getEventCasesProblemData (value = 1) {
      this.eventCasesProblem.page = value
      let params = {
        endpoints: this.eventCasesProblem.searchForm.endpoints,
        template_id: this.eventCasesProblem.searchForm.template_id,
        size: this.eventCasesProblem.size,
        page: this.eventCasesProblem.page,
        status: 'PROBLEM'
      }
      if (this.eventCasesProblem.searchForm.start_time) {
        params.start_time = this.eventCasesProblem.searchForm.start_time.getTime() / 1000
      }
      if (this.eventCasesProblem.searchForm.end_time) {
        params.end_time = this.eventCasesProblem.searchForm.end_time.getTime() / 1000 + 86400
      }
      this.eventCasesTableProblemLoading = true
      getEventCases(params).then(res => {
        this.eventCasesProblem.data = res.data.data
        this.eventCasesProblem.count = res.data.count
        this.eventCasesTableProblemLoading = false
      }).catch(res => {
        this.eventCasesTableProblemLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取未恢复的告警记录失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取未恢复的告警记录失败！服务器无响应'
          })
        }
      })
    },
    eventCaseDelete (id) {
      deleteEventCases({id: id}, id).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功'
          })
          this.getEventCasesData()
          this.getEventCasesProblemData()
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败'
        })
      })
    },
    getEndpointsFunc () {
      getEndpoints().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.allServerData = result.data
        } else {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + result.code,
            desc: result.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getAllTemplateList () {
      getAllAlarmTemplate().then(res => {
        let result = res.data
        if (result.code !== 200) {
          this.allTemplateData = []
        } else {
          this.allTemplateData = result.data
        }
      })
    },
    eventCasesSearchReset () {
      this.eventCases.searchForm.start_time = ''
      this.eventCases.searchForm.end_time = ''
      this.eventCases.searchForm.endpoints = []
      this.eventCases.searchForm.template_id = ''
    },
    eventCasesSearchProblemReset () {
      this.eventCasesProblem.searchForm.start_time = ''
      this.eventCasesProblem.searchForm.end_time = ''
      this.eventCasesProblem.searchForm.endpoints = []
      this.eventCasesProblem.searchForm.template_id = ''
    },
    getNowTime (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let day = date.getDate()
      let hour = date.getHours() + ':'
      let minute = date.getMinutes() + ':'
      let second = date.getSeconds()
      let nowTime = year + '-' + month + '-' + day
      if (type !== 'date') {
        nowTime += ' ' + hour + minute + second
      }
      return nowTime
    },
    daysBetween (time) {
      let d = new Date(time)
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    },
    // daysBetween (sDate1) {
    //   let time1 = Date.parse(new Date(sDate1))
    //   let time2 = Date.parse(new Date(this.getNowTime()))
    //   let nDays = parseInt((time1 - time2) / 1000 / 3600 / 24)
    //   if (nDays) {
    //     if (time1 > time2) {
    //       return nDays + '天前'
    //     } else {
    //       return -nDays + '天前'
    //     }
    //   } else if (parseInt((time1 - time2) / 1000 / 3600)) {
    //     if (time1 > time2) {
    //       return parseInt((time1 - time2) / 1000 / 3600) + '小时前'
    //     } else {
    //       return -parseInt((time1 - time2) / 1000 / 3600) + '小时前'
    //     }
    //   } else if (parseInt((time1 - time2) / 1000 / 60)) {
    //     if (time1 > time2) {
    //       return parseInt((time1 - time2) / 1000 / 60) + '分钟前'
    //     } else {
    //       return -parseInt((time1 - time2) / 1000 / 60) + '分钟前'
    //     }
    //   } else {
    //     return '刚刚'
    //   }
    // },
    eventsModalOpen (row) {
      this.$refs.alarmLogsEventsModal.eventsModalOpen(row)
    },
    dateFormat (date) {
      function change (t) {
        if (t < 10) {
          return '0' + t
        } else {
          return t
        }
      }
      let d = new Date(date)
      let year = d.getFullYear()
      let month = change(d.getMonth() + 1)
      let day = change(d.getDate())
      let hour = change(d.getHours())
      let minute = change(d.getMinutes())
      let second = change(d.getSeconds())
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
